import { Route } from "react-router-dom";

import {
  CREATE_PROJECT,
  EDIT_PROJECT,
  VIEW_ALL_TASK,
  VIEW_ASSIGNED_TASK,
  VIEW_GOVERNMENT_INVOICE,
  VIEW_PERFORMANCE_GUARANTEE,
  VIEW_PROJECT,
  VIEW_STAGE,
} from "src/constants";
import { PROJECT_ROUTES } from "src/pages/project/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { AddEditProject } from "./AddEditProject.page";
import { ProjectClientInvoice } from "./ProjectClientInvoice.page";
import { ProjectPerformanceGuarantees } from "./ProjectPerformanceGuarantees.page";
import { Projects } from "./Projects.page";
import { ProjectStage } from "./ProjectStage.page";
import { ProjectTask } from "./ProjectTask.page";
import { SingleProject } from "./SingleProject.page";

/** Route tree for the project module, mounted under `/projects`. */
export const projectRoutes = (
  <Route path={PROJECT_ROUTES.root}>
    <Route index element={<ProtectedRoute permissions={VIEW_PROJECT} component={Projects} />} />
    <Route path={PROJECT_ROUTES.details} element={<ProtectedRoute permissions={VIEW_PROJECT} component={SingleProject} />} />
    <Route path={PROJECT_ROUTES.add} element={<ProtectedRoute permissions={CREATE_PROJECT} component={AddEditProject} />} />
    <Route path={PROJECT_ROUTES.edit} element={<ProtectedRoute permissions={EDIT_PROJECT} component={AddEditProject} />} />
    <Route path={PROJECT_ROUTES.stages} element={<ProtectedRoute permissions={VIEW_STAGE} component={ProjectStage} />} />
    <Route
      path={PROJECT_ROUTES.tasks}
      element={<ProtectedRoute permissions={[VIEW_ALL_TASK, VIEW_ASSIGNED_TASK]} component={ProjectTask} />}
    />
    <Route
      path={PROJECT_ROUTES.invoices}
      element={<ProtectedRoute permissions={[VIEW_GOVERNMENT_INVOICE]} component={ProjectClientInvoice} />}
    />
    <Route
      path={PROJECT_ROUTES.performanceGuarantees}
      element={<ProtectedRoute permissions={VIEW_PERFORMANCE_GUARANTEE} component={ProjectPerformanceGuarantees} />}
    />
  </Route>
);
